import styles from './Card.module.css';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  /** Removes all padding — for full-bleed content inside the card */
  flush?: boolean;
  onClick?: () => void;
}

interface CardHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  className?: string;
}

interface CardBodyProps {
  children: React.ReactNode;
  className?: string;
}

interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
}

export function Card({ children, className, flush, onClick }: CardProps) {
  const classes = [
    styles.card,
    flush && styles.flush,
    onClick && styles.clickable,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (onClick) {
    return (
      <div className={classes} onClick={onClick} role="button" tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && onClick()}>
        {children}
      </div>
    );
  }

  return <div className={classes}>{children}</div>;
}

Card.Header = function CardHeader({ title, subtitle, actions, className }: CardHeaderProps) {
  return (
    <div className={[styles.header, className].filter(Boolean).join(' ')}>
      <div className={styles.headerText}>
        <h3 className={styles.title}>{title}</h3>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
};

Card.Body = function CardBody({ children, className }: CardBodyProps) {
  return <div className={[styles.body, className].filter(Boolean).join(' ')}>{children}</div>;
};

Card.Footer = function CardFooter({ children, className }: CardFooterProps) {
  return (
    <div className={[styles.footer, className].filter(Boolean).join(' ')}>{children}</div>
  );
};
